(function () {
  'use strict';

  /* =====================================================
     SETTINGS
  ===================================================== */

  const PREMIUM_PRODUCT_ID =
    10371954671898;

  const OFFER_MS =
    30000;

  const WATCH_MS =
    500;

  const DISMISSED_KEY =
    'l2l-premium-single-variant-v3';

  const VERSION =
    'premium-single-variant-v3';
    const EXPERIMENT_KEY =
  'l2l-premium-experiment-enabled';


  if (
    window.CartPremiumTimerController?.version ===
    VERSION
  ) {
    return;
  }


  /* =====================================================
     STATE
  ===================================================== */

  let previousSignature =
    null;

  let timerInterval =
    null;

  let timerEndsAt =
    0;

  let checking =
    false;

  let syncing =
    false;

  let scheduledCheck =
    null;


  /* =====================================================
     BASIC
  ===================================================== */

  function shopRoot() {

    return (
      window.Shopify?.routes?.root ||
      '/'
    );

  }

    function isExperimentEnabled() {

        /*
        * Persistent treatment assignment.
        *
        * This survives Dawn replacing
        * #cart-premium-offer.
        */
        try {

            if (
            sessionStorage.getItem(
                EXPERIMENT_KEY
            ) === '1'
            ) {

            return true;

            }

        } catch (error) {}


        const wrapper =
            document.getElementById(
            'cart-premium-offer'
            );


        if (!wrapper) {
            return false;
        }


        const enabled =
            !wrapper.classList.contains(
            'hidden'
            );


        /*
        * If your external A/B script has
        * enabled this visitor, remember it.
        */
        if (enabled) {

            try {

            sessionStorage.setItem(
                EXPERIMENT_KEY,
                '1'
            );

            } catch (error) {}

        }


        return enabled;

    }


    function syncExperimentWrapper() {

        if (
            !isExperimentEnabled()
        ) {
            return;
        }


        const wrapper =
            document.getElementById(
            'cart-premium-offer'
            );


        if (wrapper) {

            wrapper.classList.remove(
            'hidden'
            );

        }

    }




  function getUI() {

    const root =
      document.getElementById(
        'CartPremiumTimedUpsell'
      );


    if (!root) {
      return null;
    }


    return {

      root,

      timer:
        root.querySelector(
          '#CartPremiumTimer'
        ),

      progress:
        root.querySelector(
          '#L2LPremiumTimerFill'
        ),

      button:
        root.querySelector(
          '.cart-premium-mini__button'
        )

    };

  }


  /* =====================================================
     PREMIUM VARIANT
  ===================================================== */

  function getPremiumVariant() {

    const node =
      document.getElementById(
        'L2LPremiumVariantData'
      );


    if (!node) {
      return null;
    }


    try {

      const data =
        JSON.parse(
          node.textContent || '{}'
        );


      if (!data.id) {
        return null;
      }


      return data;

    }

    catch (error) {

      console.error(
        '[Premium Upgrade] Invalid variant data',
        error
      );


      return null;

    }

  }


  /* =====================================================
     CART
  ===================================================== */

  async function fetchCart() {

    const response =
      await fetch(
        shopRoot() + 'cart.js',
        {
          credentials:
            'same-origin',

          cache:
            'no-store'
        }
      );


    if (!response.ok) {

      throw new Error(
        'Unable to load cart.'
      );

    }


    return response.json();

  }


  function getPremiumLines(
    cart
  ) {

    return cart.items.filter(
      function (item) {

        return (
          Number(item.product_id) ===
          PREMIUM_PRODUCT_ID
        );

      }
    );

  }


  function premiumExists(
    cart
  ) {

    return (
      getPremiumLines(cart).length > 0
    );

  }


  /* =====================================================
     PHYSICAL PRODUCTS

     Premium itself is excluded.
  ===================================================== */

  function getPhysicalQuantity(
    cart
  ) {

    return cart.items.reduce(
      function (
        total,
        item
      ) {

        if (
          Number(item.product_id) ===
          PREMIUM_PRODUCT_ID
        ) {

          return total;

        }


        if (
          !item.requires_shipping
        ) {

          return total;

        }


        return (
          total +
          Number(item.quantity || 0)
        );

      },
      0
    );

  }


  /* =====================================================
     REAL CART SIGNATURE

     Premium is deliberately excluded.
  ===================================================== */

  function createSignature(
    cart
  ) {

    return cart.items

      .filter(
        function (item) {

          return (
            Number(item.product_id) !==
            PREMIUM_PRODUCT_ID
          );

        }
      )

      .map(
        function (item) {

          return [

            item.key,

            item.variant_id,

            item.quantity

          ].join(':');

        }
      )

      .sort()

      .join('|');

  }


  /* =====================================================
     DISMISSED STATE
  ===================================================== */

  function getDismissedSignature() {

    try {

      return (
        sessionStorage.getItem(
          DISMISSED_KEY
        ) || ''
      );

    }

    catch (error) {

      return '';

    }

  }


  function dismissSignature(
    signature
  ) {

    if (!signature) {
      return;
    }


    try {

      sessionStorage.setItem(
        DISMISSED_KEY,
        signature
      );

    }

    catch (error) {}

  }


  function clearDismissed() {

    try {

      sessionStorage.removeItem(
        DISMISSED_KEY
      );

    }

    catch (error) {}

  }


  function isDismissed(
    signature
  ) {

    return (
      getDismissedSignature() ===
      signature
    );

  }


  /* =====================================================
     TIMER
  ===================================================== */

  function stopTimer() {

    if (
      timerInterval
    ) {

      clearInterval(
        timerInterval
      );


      timerInterval =
        null;

    }


    timerEndsAt =
      0;

  }


  function renderTimer(
    milliseconds
  ) {

    const ui =
      getUI();


    if (!ui) {
      return;
    }


    const remaining =
      Math.max(
        0,
        milliseconds
      );


    const seconds =
      Math.ceil(
        remaining / 1000
      );


    if (
      ui.timer
    ) {

      ui.timer.textContent =
        '00:' +
        String(seconds).padStart(
          2,
          '0'
        );

    }


    if (
      ui.progress
    ) {

      const ratio =
        Math.max(
          0,
          Math.min(
            1,
            remaining / OFFER_MS
          )
        );


      ui.progress.style.transform =
        'scaleX(' +
        ratio +
        ')';

    }

  }


  function hideOffer(
    signature,
    remember = false
  ) {

    stopTimer();


    const ui =
      getUI();


    if (ui) {

      ui.root.classList.add(
        'cart-premium-mini--js-pending'
      );


      ui.root.classList.add(
        'is-expired'
      );

    }


    if (
      remember &&
      signature
    ) {

      dismissSignature(
        signature
      );

    }

  }


  function startOffer(
    signature
  ) {

            /*
        * A/B test says this visitor should
        * NOT see the Premium offer.
        *
        * Do not start timer in background.
        * Do not dismiss the offer either.
        */
        if (
            !isExperimentEnabled()
        ) {

            return;

        }

    if (
      !signature ||
      isDismissed(signature)
    ) {

      hideOffer(
        signature,
        false
      );


      return;

    }


    const ui =
      getUI();


    if (!ui) {
      return;
    }


    if (
      ui.root.classList.contains(
        'cart-premium-mini--empty'
      )
    ) {

      return;

    }


    stopTimer();


    ui.root.classList.remove(
      'cart-premium-mini--js-pending'
    );


    ui.root.classList.remove(
      'is-expired'
    );


    timerEndsAt =
      Date.now() + OFFER_MS;


    renderTimer(
      OFFER_MS
    );


    timerInterval =
      setInterval(
        function () {

          const remaining =
            timerEndsAt -
            Date.now();


          if (
            remaining <= 0
          ) {

            renderTimer(0);


            hideOffer(
              signature,
              true
            );


            return;

          }


          renderTimer(
            remaining
          );

        },
        100
      );

  }


  /* =====================================================
     CHANGE CART LINE
  ===================================================== */

  async function changeLine(
    key,
    quantity
  ) {

    const response =
      await fetch(
        shopRoot() +
        'cart/change.js',
        {
          method:
            'POST',

          credentials:
            'same-origin',

          headers: {

            'Content-Type':
              'application/json',

            'Accept':
              'application/json'

          },

          body:
            JSON.stringify(
              {

                id:
                  key,

                quantity:
                  quantity

              }
            )
        }
      );


    if (!response.ok) {

      throw new Error(
        'Unable to update Premium Upgrade.'
      );

    }


    return response.json();

  }


  /* =====================================================
     ADD PREMIUM

     No line-item properties.

     Premium quantity =
     physical product quantity.
  ===================================================== */

  async function addPremium(
    variantId,
    quantity
  ) {

    const response =
      await fetch(
        shopRoot() +
        'cart/add.js',
        {
          method:
            'POST',

          credentials:
            'same-origin',

          headers: {

            'Content-Type':
              'application/json',

            'Accept':
              'application/json'

          },

          body:
            JSON.stringify(
              {

                items: [

                  {

                    id:
                      variantId,

                    quantity:
                      quantity

                  }

                ]

              }
            )
        }
      );


    const data =
      await response
        .json()
        .catch(
          function () {

            return {};

          }
        );


    if (!response.ok) {

      throw new Error(
        data.description ||
        'Unable to add Premium Upgrade.'
      );

    }


    return data;

  }


  /* =====================================================
     PREMIUM SYNC

     Premium variant never changes.

     Only quantity changes.
  ===================================================== */

  async function syncPremium(
    cart
  ) {

    if (
      syncing
    ) {

      return cart;

    }


    const premiumLines =
      getPremiumLines(
        cart
      );


    /*
     * Never automatically add Premium.
     */

    if (
      premiumLines.length === 0
    ) {

      return cart;

    }


    syncing =
      true;


    try {

      const physicalQuantity =
        getPhysicalQuantity(
          cart
        );


      /*
       * Physical products all removed.
       */

      if (
        physicalQuantity <= 0
      ) {

        for (
          const line
          of premiumLines
        ) {

          await changeLine(
            line.key,
            0
          );

        }


        return await fetchCart();

      }


      const variant =
        getPremiumVariant();


      if (!variant) {

        throw new Error(
          'Premium variant not found.'
        );

      }


      /*
       * Find clean current Premium line.
       */

      let primaryLine =
        premiumLines.find(
          function (line) {

            return (
              Number(line.variant_id) ===
              Number(variant.id)
            );

          }
        );


      /*
       * Remove duplicate / old Premium lines.
       */

      for (
        const line
        of premiumLines
      ) {

        if (
          !primaryLine ||
          line.key !==
          primaryLine.key
        ) {

          await changeLine(
            line.key,
            0
          );

        }

      }


      /*
       * Correct Premium line exists.
       *
       * Only synchronize quantity.
       */

      if (
        primaryLine
      ) {

        if (
          Number(primaryLine.quantity) !==
          physicalQuantity
        ) {

          await changeLine(
            primaryLine.key,
            physicalQuantity
          );

        }


        return await fetchCart();

      }


      /*
       * Old Premium variant/line existed,
       * but correct single variant does not.
       */

      await addPremium(
        variant.id,
        physicalQuantity
      );


      return await fetchCart();

    }

    finally {

      syncing =
        false;

    }

  }


  /* =====================================================
     REFRESH DRAWER
  ===================================================== */

  async function refreshDrawer() {

    const drawer =
      document.querySelector(
        'cart-drawer'
      );


    if (!drawer) {
      return;
    }


    if (
      typeof drawer.renderContents !==
        'function'

      ||

      typeof drawer.getSectionsToRender !==
        'function'
    ) {

      document.dispatchEvent(
        new CustomEvent(
          'cart:refresh',
          {
            bubbles: true
          }
        )
      );


      return;

    }


    const sections =
      drawer
        .getSectionsToRender()
        .map(
          function (section) {

            return section.id;

          }
        );


    if (!sections.length) {
      return;
    }


    const response =
      await fetch(
        shopRoot() +
        '?sections=' +
        encodeURIComponent(
          sections.join(',')
        ),
        {
          credentials:
            'same-origin',

          cache:
            'no-store'
        }
      );


    if (!response.ok) {
      return;
    }


    const data =
      await response.json();


    drawer.renderContents(
      {
        sections:
          data
      }
    );

    /*
    * Dawn has created a brand-new
    * A/B wrapper with class="hidden".
    *
    * Restore the visitor's treatment.
    */
    syncExperimentWrapper();

  }


  /* =====================================================
     CHECK CART
  ===================================================== */

  async function checkCart() {

    if (
      checking ||
      syncing
    ) {

      return;

    }


    checking =
      true;


    try {

      let cart =
        await fetchCart();


      const signature =
        createSignature(
          cart
        );


      /* ===============================================
         FIRST LOAD
      =============================================== */

      if (
        previousSignature === null
      ) {

        previousSignature =
          signature;


        if (
          premiumExists(cart)
        ) {

          dismissSignature(
            signature
          );


          hideOffer(
            signature,
            false
          );


          cart =
            await syncPremium(
              cart
            );


          await refreshDrawer();


          return;

        }


        if (
          isDismissed(signature)
        ) {

          hideOffer(
            signature,
            false
          );


          return;

        }


        if (
          getPhysicalQuantity(cart) > 0
        ) {

          startOffer(
            signature
          );

        }


        return;

      }


      /* ===============================================
         SAME ACTUAL PRODUCTS
      =============================================== */

      if (
        signature ===
        previousSignature
        ) {

        /*
        * Premium is already active.
        *
        * Keep offer hidden.
        */
        if (
            premiumExists(
            cart
            )
        ) {

            dismissSignature(
            signature
            );


            hideOffer(
            signature,
            false
            );


            
            await syncPremium(
                cart
            );

            await refreshDrawer();


            return;

        }


        /*
        * Customer already used the offer
        * or timer already expired.
        *
        * Removing Premium alone must NOT
        * make the card visible again.
        */
        if (
            isDismissed(
            signature
            )
        ) {

            hideOffer(
            signature,
            false
            );


            return;

        }


        /*
        * A/B TEST CASE
        *
        * The page may have loaded while
        * #cart-premium-offer was hidden.
        *
        * If the A/B script has now enabled
        * this customer, start the offer even
        * though cart products did not change.
        */
        if (
            isExperimentEnabled()
            &&
            getPhysicalQuantity(cart) > 0
            &&
            !timerInterval
        ) {

            startOffer(
            signature
            );

        }


        return;

        }

    


      /* ===============================================
         REAL PRODUCT CHANGED
      =============================================== */

      previousSignature =
        signature;


      /*
       * New real cart state can have a new offer.
       *
       * Removing Premium alone can never reach
       * this block.
       */

      clearDismissed();


      /*
       * Premium already active:
       *
       * Hide upsell and synchronize its qty.
       */

      if (
        premiumExists(cart)
      ) {

        hideOffer(
          signature,
          false
        );


        dismissSignature(
          signature
        );


        cart =
          await syncPremium(
            cart
          );


        previousSignature =
          createSignature(
            cart
          );


        await refreshDrawer();


        return;

      }


      /*
       * No physical products.
       */

      if (
        getPhysicalQuantity(cart) <= 0
      ) {

        hideOffer(
          signature,
          false
        );


        return;

      }


      /*
       * Refresh Liquid so displayed
       * discounted price matches qty.
       */

      await refreshDrawer();


      setTimeout(
        function () {

          startOffer(
            signature
          );

        },
        80
      );

    }

    catch (error) {

      console.error(
        '[Premium Upgrade]',
        error
      );

    }

    finally {

      checking =
        false;

    }

  }


  /* =====================================================
     UPGRADE BUTTON
  ===================================================== */

  document.addEventListener(
    'click',

    async function (
      event
    ) {

      const button =
        event.target.closest?.(
          '.cart-premium-mini__button'
        );


      if (!button) {
        return;
      }


      event.preventDefault();

      event.stopPropagation();


      if (
        syncing
      ) {

        return;

      }


      const originalHTML =
        button.innerHTML;


      button.disabled =
        true;


      button.innerHTML =
        'Adding Premium Upgrade…';


      try {

        const cart =
          await fetchCart();


        const signature =
          createSignature(
            cart
          );


        const physicalQuantity =
          getPhysicalQuantity(
            cart
          );


        if (
          physicalQuantity <= 0
        ) {

          throw new Error(
            'No eligible physical products found.'
          );

        }


        const variant =
          getPremiumVariant();


        if (!variant) {

          throw new Error(
            'Premium variant not found.'
          );

        }


        /*
         * Hide immediately.
         */

        hideOffer(
          signature,
          false
        );


        /*
         * Remove any previous Premium lines
         * to guarantee a clean single line.
         */

        const existingPremium =
          getPremiumLines(
            cart
          );


        syncing =
          true;


        try {

          for (
            const line
            of existingPremium
          ) {

            await changeLine(
              line.key,
              0
            );

          }


          await addPremium(
            variant.id,
            physicalQuantity
          );

        }

        finally {

          syncing =
            false;

        }


        /*
         * Same actual product state should
         * not receive another Premium offer.
         */

        dismissSignature(
          signature
        );


        previousSignature =
          signature;


        await refreshDrawer();

      }

      catch (error) {

        console.error(
          '[Premium Upgrade]',
          error
        );


        if (
          document.body.contains(
            button
          )
        ) {

          button.disabled =
            false;


          button.innerHTML =
            originalHTML;

        }


        alert(
          error.message ||
          'Unable to add Premium Upgrade.'
        );

      }

    }
  );


  /* =====================================================
     FAST CART CHANGE DETECTION
  ===================================================== */

  function scheduleCheck(
    delay = 100
  ) {

    clearTimeout(
      scheduledCheck
    );


    scheduledCheck =
      setTimeout(
        checkCart,
        delay
      );

  }


  document.addEventListener(
    'change',

    function (event) {

      if (
        event.target.closest?.(
          'cart-drawer'
        )
      ) {

        scheduleCheck(
          100
        );

      }

    },

    true
  );


  document.addEventListener(
    'click',

    function (event) {

      /*
       * Do not trigger watcher because
       * customer clicked our own CTA.
       */

      if (
        event.target.closest?.(
          '.cart-premium-mini__button'
        )
      ) {

        return;

      }


      if (
        event.target.closest?.(
          'cart-drawer'
        )
      ) {

        scheduleCheck(
          140
        );

      }

    },

    true
  );


  const observer =
    new MutationObserver(
      function () {

        scheduleCheck(
          70
        );

      }
    );


  const drawer =
    document.querySelector(
      'cart-drawer'
    );


  if (drawer) {

    observer.observe(
      drawer,
      {

        childList:
          true,

        subtree:
          true

      }
    );

  }


  /* =====================================================
     FALLBACK
  ===================================================== */

  setInterval(
    checkCart,
    WATCH_MS
  );


  setTimeout(
    checkCart,
    200
  );


  /* =====================================================
     PUBLIC
  ===================================================== */

  window.CartPremiumTimerController = {

    version:
      VERSION,

    check:
      checkCart,

    show:
      startOffer,

    hide:
      hideOffer,

    sync:
      async function () {

        let cart =
          await fetchCart();


        cart =
          await syncPremium(
            cart
          );


        await refreshDrawer();


        return cart;

      }

  };


  /* =====================================================
    A/B EXPERIMENT OBSERVER
    ===================================================== */

    const experimentObserver =
    new MutationObserver(
        function () {

        const wrapper =
            document.getElementById(
            'cart-premium-offer'
            );


        if (!wrapper) {
            return;
        }


        /*
        * A/B script enabled Premium
        * for this visitor.
        */
        if (
            !wrapper.classList.contains(
            'hidden'
            )
        ) {

            try {

            sessionStorage.setItem(
                EXPERIMENT_KEY,
                '1'
            );

            } catch (error) {}


            scheduleCheck(
            20
            );


            return;

        }


        /*
        * Dawn created a new wrapper
        * containing class="hidden".
        *
        * If this visitor was already
        * assigned to Premium treatment,
        * immediately restore it.
        */
        syncExperimentWrapper();

        }
    );


    experimentObserver.observe(
    document.body,
    {
        childList:
        true,

        subtree:
        true,

        attributes:
        true,

        attributeFilter: [
        'class'
        ]
    }
    );

})();

